import { useRoutes } from 'react-router';
import useLegacyRoutes from 'src/legacy/routes';

import { privateAppRoutes, publicAppRoutes } from './routes';

export const AppRoutes = () => {
  const legacyRoutes = useLegacyRoutes({ privateAppRoutes });
  return useRoutes([...legacyRoutes, ...publicAppRoutes]);
};
